import { Navigate, Outlet } from "react-router-dom";
import { isFournisseurAuthenticated } from "../utils/auth";

export default function PublicFournisseurRoute() {
    return isFournisseurAuthenticated() ? (
        <Navigate to="/fournisseur/dashboard" replace />
    ) : (
        <Outlet />
    );
}
